import axios from "axios";
import store from "../store/index";
import { showMessage } from "../components/util/NoticeMessage";
import { logout } from "../store/user/actionCreators";
import { setMessage } from "../store/global/actionCreators";

let config = {
  baseURL: "",
  transformRequest: [
    function (data) {
      let ret = JSON.stringify(data);
      return ret;
    },
  ],
  transformResponse: [],
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    "Content-Type": "application/json;charset=UTF-8",
  },
  timeout: 10000,
  responseType: "json",
};

function createUrlWithToken(url) {
  // const { store } = configureStore();

  return url;
}

axios.interceptors.response.use(
  function (res) {
    //相应拦截器
    if (
      res &&
      res.data &&
      (res.data.message === "无权限访问" ||
        res.data.message ===
          "您的身份未认证或者您的认证信息已过期，请重新认证。")
    ) {
      // const user = store.getState().user;
      store.dispatch(
        setMessage({
          type: "error",
          msg: "您的身份未认证或者您的认证信息已过期，请重新认证。",
        })
      );
      store.dispatch(logout());
      // if (user.isLogin) {
      //   store.dispatch(setMessage({
      //     type: 'error',
      //     msg: '您的身份未认证或者您的认证信息已过期，请重新认证。',
      //   }));
      //   store.dispatch(logout());
      // }
      return;
    }

    if (res && res.data && res.data.message) {
      store.dispatch(
        setMessage({
          type: res.data.success ? "success" : "error",
          msg: res.data.message,
        })
      );
    }
    return res.data;
  },
  function (error) {
    // 对响应错误做点什么
    let msg = error.msg || error.response?.data?.message;
    let authfail = false;
    console.log(error);
    if (error && error.response) {
      if (error.response.status === 500) {
        msg = msg ? msg : "服务器内部错误";
      } else if (error.response.status === 401) {
        authfail = true;
      } else if (error.response.status === 403) {
        msg = msg ? msg : "您没有相关权限";
      } else if (error.response.status === 400) {
        msg = msg ? msg : "参数错误";
      } else if (error.response.status === 404) {
        msg = "找不到该请求";
      }

      if (authfail) {
        // localStorage.removeItem('user');
        setTimeout(() => {
          // const user = store.getState().user;
          // if (user.isLogin) {
          store.dispatch(
            setMessage({
              type: "error",
              msg: "您的身份未认证或者您的认证信息已过期，请重新认证。",
            })
          );
          store.dispatch(logout());
          // }
        }, 2000);
      }
    }
    if (!authfail) {
      store.dispatch(setMessage({ type: "error", msg: msg }));
    }
    return Promise.reject(error);
  }
);

export function get(url, data) {
  let requrl = createUrlWithToken(url);
  return axios.get(
    requrl,
    {
      params: data,
    },
    config
  );
}

export function post(url, data) {
  let requrl = createUrlWithToken(url);
  return axios.post(requrl, data, config);
}

export function postWithToken(url, data) {
  return axios.post(url, data, config);
}

export function del(url, data) {
  let requrl = createUrlWithToken(url);
  return axios.delete(
    requrl,
    {
      params: data,
    },
    config
  );
}

export function put(url, data) {
  let requrl = createUrlWithToken(url);
  return axios.put(requrl, data, config);
}

export function postFile(url, formData, config) {
  let requrl = createUrlWithToken(url);
  return axios.post(requrl, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Access-Control-Allow-Origin": "*",
    },
    ...config,
  });
}

export function downloadFile(url, data, method) {
  const isSupportDownload = "download" in document.createElement("a");
  showMessage("info", `isSupportDownload ${isSupportDownload}`);
  let requrl = createUrlWithToken(url);
  if (!method || method === "GET") {
    axios
      .get(requrl, data, {
        responseType: "blob",
        "Access-Control-Allow-Origin": "*",
      })
      .then((res, res2) => {
        let url = window.URL.createObjectURL(new Blob([res]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", data.fileName); // 获取并设置下载文件名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      });
  } else if (method === "POST") {
    axios
      .post(requrl, data, {
        responseType: "blob",
        "Access-Control-Allow-Origin": "*",
      })
      .then((res, res2) => {
        // let url = window.URL.createObjectURL(new Blob([res]))
        // let link = document.createElement('a')
        // link.style.display = 'none'
        // link.href = url
        // link.setAttribute('download', data.fileName)  // 获取并设置下载文件名
        // document.body.appendChild(link)
        // link.click()
        // document.body.removeChild(link);
        // window.URL.revokeObjectURL(link.href);

        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        let fileName = data.fileName;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();

        //let url = window.URL.createObjectURL(new Blob([res]))
        //window.open(url);

        // const blob = new Blob([res]);
        // FileSaver.saveAs(blob, data.fileName);
      });
  }
}
